import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { clearToken } from "../utils/reducers/authSlice";

const TokenChecker = () => {
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.token);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiration = () => {
      if (authToken && authToken.token) {
        try {
          const decodedToken = jwtDecode(authToken.token);
          const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
          if (decodedToken.exp < currentTime) {
            dispatch(clearToken());
            alert("Your session has expired. Please log in again.");
            navigate("/login");
            //setShowLoginModal(true); // Show login modal
          }
        } catch (error) {
          console.error("Error decoding token:", error);
          // Handle error if token cannot be decoded
        }
      }
    };

    const intervalId = setInterval(checkTokenExpiration, 1000); // Run every second

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [dispatch, authToken]);

  const handleLogin = () => {
    // Implement redirect logic to the login page
    // You can use React Router's history object or window.location.href to redirect
    console.log("Redirecting to login page...");
  };

  return (
    <>
      {/* Bootstrap modal */}
      <div
        className={`modal fade${showLoginModal ? " show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: showLoginModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Session Expired</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowLoginModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <p>Your session has expired. Please log in again.</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleLogin}
              >
                Go to Login
              </button>
            </div>
          </div>
        </div>
      </div>
      {showLoginModal && (
        <div
          className="modal-backdrop fade show"
          style={{
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        ></div>
      )}
    </>
  );
};

export default TokenChecker;
